import { useWizardStateContext } from '../_contexts/WizardStateProvider';
import StepImage from './StepImage';
import getWizardData from './utils/getWizardData';

const ChargerModelStepImage = () => {
  const { currentRoute } = useWizardStateContext();

  const accessory = currentRoute.accessory;

  const wizard = getWizardData({ accessory: accessory.value });
  const styleStep = wizard?.styleStep;
  const image = styleStep?.image;

  return <StepImage image={image} />;
};

export default ChargerModelStepImage;
